import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dvkttbmnugglnuaoovyr.supabase.co';
const supabaseAnonKey = "sb_publishable_VwdKJ5BVBhZ6kk3SoI7UeQ_1C9VztBB"
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
